module.exports = __webpack_public_path__ + "static/media/invite.a39e2d71.less";